import {PAYMENT_REQUEST} from '../actions/payment'
export const payment = (state={res:null},action)=>{
    switch(action.type){
        case PAYMENT_REQUEST :
            return state = {res:action.data}
        default : return state
    }

}